import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import ReactHookFormRadio from "../../../components/common/form/ReactHookFormRadio";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Radio from "@material-ui/core/Radio";
import { contentManagerSchema } from "./schema/contentManager";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";

const useStyles = makeStyles((theme) => ({
  buttons: {
    display: "flex",
    justifyContent: "flex-start",
    width: "100%",
  },
  buttonAdd: {
    marginLeft: theme.spacing(1),
  },
}));

const Add = (props) => {
  const classes = useStyles();
  const {
    isEnabledFormAddAdmin,
    addHandler,
    loading,
    show,
    translateValidation,
  } = props;
  const { register, handleSubmit, errors, reset, control } = useForm({
    resolver: yupResolver(contentManagerSchema(translateValidation)),
  });

  const onsubmit = (data) => {
    reset();
    addHandler(data);
  };
  return (
    <Box component="span" display={isEnabledFormAddAdmin ? "none" : "block"}>
      <Paper elevation={1}>
        <Container maxWidth={false} className={classes.container}>
          <Typography
            className={classes.title}
            variant="h5"
            component="h1"
            gutterBottom
          >
            {translateValidation.title}
          </Typography>

          <form fullWidth onSubmit={handleSubmit(onsubmit)} noValidate>
            <Grid container spacing={3}>
              <Grid item xs={12} sm={12} lg={4}>
                <TextField
                  inputRef={register}
                  error={errors.name && true}
                  helperText={errors.name && errors.name.message}
                  id="name"
                  name="name"
                  label={translateValidation.name.label}
                  placeholder={translateValidation.name.placeholder}
                  fullWidth
                />
              </Grid>

              <Grid item xs={12} sm={12} lg={4}>
                <TextField
                  inputRef={register}
                  error={errors.email && true}
                  helperText={errors.email && errors.email.message}
                  id="email"
                  name="email"
                  label={translateValidation.email.label}
                  placeholder={translateValidation.email.placeholder}
                  fullWidth
                />
              </Grid>

              <Grid item xs={12} sm={12} lg={4}>
                <ReactHookFormRadio
                  inputRef={register}
                  error={errors.role && true}
                  helperText={errors.role && errors.role.message}
                  id="role"
                  name="role"
                  label={translateValidation.role.label}
                  style={{ width: "100%" }}
                  control={control}
                  defaultValue="time_de_conteudo_xperience"
                >
                  <FormControlLabel
                    value="time_de_conteudo_xperience"
                    control={<Radio />}
                    label={
                      translateValidation.role.options.xperienceContentTeam
                        .label
                    }
                  />
                  <FormControlLabel
                    value="criador_de_conteudo_externo"
                    control={<Radio />}
                    label={
                      translateValidation.role.options.externalContentCreator
                        .label
                    }
                  />
                </ReactHookFormRadio>
              </Grid>

              <Grid item xs={12} sm={12} lg={12}>
                <div className={classes.buttons}>
                  <Button
                    variant="outlined"
                    color="secondary"
                    disabled={loading}
                    onClick={show}
                  >
                    {translateValidation.cancelButton}
                  </Button>
                  <Button
                    type="submit"
                    variant="contained"
                    color="primary"
                    className={classes.buttonAdd}
                    disabled={loading}
                  >
                    {translateValidation.confirmButton}
                  </Button>
                </div>
              </Grid>
            </Grid>
          </form>
        </Container>
      </Paper>
    </Box>
  );
};

export default Add;
